export default function Info() {
  return (
    <div>
      <ul>
        <li>
          <p>"AFM search" Android app</p>
          <p>Download at Google Play (tap the icon please) </p>
          <a href="https://play.google.com/store/apps/details?id=com.st_app.working_gsis_template">
            <img
              src={require("../assets/ic_launcher.png")}
              alt="app logo"
            ></img>
          </a>
        </li>
      </ul>
    </div>
  );
}
